module.exports = __webpack_public_path__ + "assets/grey_check_mark-f8d42c.svg";